<div class="registration-supplementary-equipment" *ngIf="registration">

  <sc-flex fitHeight>
    <div class="options-list">
      <sc-flex vertical stretchContent>
        <mat-form-field *ngIf="cps.isPropertyTrue('visitoverview.register.messagingLanguage', false)" appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.registration.messagingLanguage"></sc-dictionary-label>
          </mat-label>
          <mat-select name="messagingLanguage" [(ngModel)]="registration.transport.messaging.messagingLanguage"
            #messagingLanguageType="ngModel" [required]="true">
            <mat-option *ngFor="let o of getMessagingLanguagesOrdererByCurrentTranslation()"
              value="{{o}}">
              <sc-dictionary-label dictionaryKey="common.enum.language.{{o}}"></sc-dictionary-label>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="form-checkbox">
          <div class="checkbox-label">
            <mat-checkbox class="col first" name="useGlobalConnect" [(ngModel)]="registration.transport.messaging.useGlobalConnect"
              #useGlobalConnect="ngModel">
              <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.messaging.useGlobalConnect"></sc-dictionary-label>
            </mat-checkbox>
          </div>
        </div>
        <div class="form-checkbox">
          <div class="checkbox-label">
            <mat-checkbox *ngIf="cps.isPropertyTrue('feature.sms', false)" class="col first" name="useSms" [(ngModel)]="registration.transport.messaging.useSms"
              #useGlobalConnect="ngModel">
              <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.messaging.useSms"></sc-dictionary-label>
            </mat-checkbox>
          </div>
        </div>
      </sc-flex>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="options-list no-field-space"
      *ngIf="(registration.registerNow || (registration.transport.timing.planningType !== planningType.IN_ADVANCE && registration.transport.timing.planningType !== planningType.TIMEFRAME)) && !yardPropertiesService.isHideInRegisterTransportEnabled()">
      <sc-flex vertical stretchContent>
        <div class="form-checkbox no-supplementary-cbx"
          *ngIf="yardPropertiesService.isShowNoHandoutEnabled()">
          <div class="checkbox-label">
            <mat-checkbox [(ngModel)]="registration.noSupplementaryEquipmentHandout"
              [ngModelOptions]="{standalone: true}" [disabled]="isNoSupplementaryEquipmentHandoutDisabled()">
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.registration.supplementaryEquipment.nosupplementaryequipmenthandout"></sc-dictionary-label>
            </mat-checkbox>
          </div>
        </div>
        <sc-content-spacer vertical></sc-content-spacer>
        <div *ngFor="let se of registration.supplementaryEquipments">
          <sc-flex >
            <div class="checkbox-label">
              <mat-checkbox [(ngModel)]="se.selected" [ngModelOptions]="{standalone: true}"
                [disabled]="isNoSupplementaryEquipmentHandoutSelected()">
                <sc-dictionary-label [dictionaryKey]="se.dictionaryKey"></sc-dictionary-label>
              </mat-checkbox>
            </div>
            <sc-content-spacer></sc-content-spacer>
            <mat-form-field class="checkbox-value" *ngIf="isStringParameter(se)" appearance="fill">
              <mat-label>
                <sc-dictionary-label [dictionaryKey]="se.parameter1DictionaryKey"></sc-dictionary-label>
              </mat-label>
              <input class="value-input" matInput [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: true}"
                required [disabled]="!se.selected" />
            </mat-form-field>
            <sc-content-spacer></sc-content-spacer>
            <mat-form-field class="checkbox-value" *ngIf="isNumberParameter(se)" appearance="fill">
              <mat-label>
                <sc-dictionary-label [dictionaryKey]="se.parameter1DictionaryKey"></sc-dictionary-label>
              </mat-label>
              <input class="value-input" [type]="'number'" matInput [(ngModel)]="se.parameter1Value"
                [ngModelOptions]="{standalone: true}" required [disabled]="!se.selected" />
            </mat-form-field>
          </sc-flex>
          <sc-content-spacer vertical></sc-content-spacer>
        </div>

      </sc-flex>
    </div>
  </sc-flex>



  <!-- Keine Begleitmittelausgabe für Vorabanmeldungen "wenn nicht jetzt einbuchen"-->

</div>
